<div *ngIf="readonly === true; else regularSelect">
  <div class="field__label">Language</div>
  <div class="field__text">{{selectedItemName$ | push | appEmptyValue}}</div>
</div>
<ng-template #regularSelect>
  <app-form-select-new [formControl]="formControl"
                       [data]="itemsList$ | push"
                       [label]="'Language'"></app-form-select-new>
</ng-template>
